// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-control:disabled, .form-control[readonly] {
  background-color: lightgray !important;
  opacity: 1;
}

.form-control {
  width: -moz-fit-content;
  width: fit-content;
  min-width: 250px;
  margin: 0 0 0 11px;
}

.primary {
  margin: -10px 0 0 10px !important;
}

.my-dropdown {
  margin-left: 10px !important;
}

.button-row {
  margin-top: 10px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
